import { render, staticRenderFns } from "./roots.vue?vue&type=template&id=5659870c&scoped=true&"
import script from "./roots.vue?vue&type=script&lang=js&"
export * from "./roots.vue?vue&type=script&lang=js&"
import style0 from "./roots.vue?vue&type=style&index=0&id=5659870c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5659870c",
  null
  
)

export default component.exports